export const stackableLevels = {
    department: 'department',
    category: 'category',
    subcategory:"subcategory"
}